// removed by extract-text-webpack-plugin
module.exports = {"left":"typeS__left___3nN1x breakPointS-textAlign-left","center":"typeS__center___1DkX_ breakPointS-textAlign-center","right":"typeS__right___3RGlP breakPointS-textAlign-right","top":"typeS__top___1Tgpi breakPointS-display-tableCell breakPointS-verticalAlign-top","middle":"typeS__middle___2bZpr breakPointS-display-tableCell breakPointS-verticalAlign-middle","bottom":"typeS__bottom___2G_H1 breakPointS-display-tableCell breakPointS-verticalAlign-bottom"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-align/Align/style/typeS.css
// module id = 80
// module chunks = 0 16